import styled from 'styled-components';
import Icon from '@ant-design/icons';

import HotProjects from '../assets/images/icons/icon-hot.png';
import NewPullIcon from '../assets/images/icons/newpush.png';
import NewSub from '../assets/images/icons/newsubmit.png';
import NewPub from '../assets/images/icons/newpublic.png';
import UserPNG from '../assets/images/icons/user.png';
import DatePNG from '../assets/images/icons/date.png';
import Type0 from '../assets/images/icons/type-0.png';
import Type1 from '../assets/images/icons/type-1.png';
import Type2 from '../assets/images/icons/type-2.png';

import companyTypeIcon from '../assets/images/icons/company-type.png';
import TwoFaConfigured from '../assets/images/icons/2fa-configured.png';

import ArticlesPNG from '../assets/images/icons/Ann.png';

import Hot from '../assets/images/icons/hots.png';

import report from '../assets/images/icons/report.png';
import reports from '../assets/images/icons/reports.png';
import Comp from '../assets/images/icons/comp.png';

import gg from '../assets/images/icons/gg.png';

import myreports from '../assets/images/icons/users/my-reports.png';
import myTeam from '../assets/images/icons/users/my-team.png';
import myInfo from '../assets/images/icons/users/my-info.png';
import setAvatar from '../assets/images/icons/users/set-avatar.png';
import setPassword from '../assets/images/icons/users/set-password.png';
import twoFA_selected from '../assets/images/icons/users/2fa-selected.png';

import myreports_unselect from '../assets/images/icons/users/my-reports-noselect.png';
import myTeam_unselect from '../assets/images/icons/users/my-team-noselect.png';
import myInfo_unselect from '../assets/images/icons/users/my-info-noselect.png';
import setAvatar_unselect from '../assets/images/icons/users/set-avatar-noselect.png';
import setPassword_unselect from '../assets/images/icons/users/set-password-noselect.png';
import twoFA_unselected from '../assets/images/icons/users/2fa-unselected.png';

import Search_PNG from '../assets/images/icons/search_icon.png';
import Enter_PNG from '../assets/images/icons/enter_icon.png';
import ADDReportPNG from '../assets/images/icons/add_report.png';

import companyReport from '../assets/images/icons/company/reports.png';
import companyInfo from '../assets/images/icons/company/company-info.png';
import companyLogo from '../assets/images/icons/company/set-logo.png';
import companyPassword from '../assets/images/icons/company/set-password.png';

import companyReport_unselect from '../assets/images/icons/company/reports-unselect.png';
import companyInfo_unselect from '../assets/images/icons/company/company-info-unselect.png';
import companyLogo_unselect from '../assets/images/icons/company/set-logo-unselect.png';
import companyPassword_unselect from '../assets/images/icons/company/set-password-unselect.png';

import { useTranslation } from 'react-i18next';

const ListIcon = styled.img`
  width: 32px;
  height: 32px;
  vertical-align: top;
`;

export const HotProjectsIcon = () => {
  return <ListIcon src={HotProjects} />;
};

export const NewPullRequestIcon = () => {
  return <ListIcon src={NewPullIcon} />;
};

export const NewSubmitIcon = () => {
  return <ListIcon src={NewSub} />;
};

export const NewPublic = () => {
  return <ListIcon src={NewPub} />;
};

const User = styled.img`
  width: 10px;
  height: 10px;
  margin-right: 2px;
  vertical-align: middle;
`;

export const UserIcon = () => {
  return <User src={UserPNG} />;
};

const Date = styled.img`
  width: 10px;
  height: 10px;
  margin-right: 4px;
  vertical-align: middle;
`;

export const DateIcon = () => {
  return <Date src={DatePNG} />;
};

export const HotIcon = () => {
  return <User src={Hot} />;
};

const TypeContainer = styled.div`
  min-width: 43px;
  height: 20px;
  padding: 2px 6px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  ${(props) => props.type === 1 && `background-color: rgba(161,161,161,0.1);`}
  ${(props) => props.type === 2 && `background-color: rgba(255,149,0,0.1);`}
  ${(props) => props.type === 3 && `background-color: rgba(255,62,0,0.1);`};

  ${(props) => props.type === 1 && `color: rgba(161,161,161,1);`}
  ${(props) => props.type === 2 && `color: rgba(255,149,0,1);`}
  ${(props) => props.type === 3 && `color: rgba(255,62,0,1);`};
`;

const Type = styled.img`
  width: 11px;
  height: 10px;
  margin-right: 4px;
`;

export const TypeIcon = ({ type }) => {
  const { t } = useTranslation();
  let Icon;
  switch (type) {
    case 1:
      Icon = Type0;
      break;
    case 2:
      Icon = Type1;
      break;
    case 3:
      Icon = Type2;
      break;
    default:
      Icon = Type0;
      break;
  }
  return (
    <TypeContainer type={type}>
      <Type src={Icon} />
      {type === 1
        ? t('levelTag.low')
        : type === 2
        ? t('levelTag.mid')
        : t('levelTag.high')}
    </TypeContainer>
  );
};

const Articles = styled.img`
  width: 32px;
  height: 32px;
  vertical-align: top;
`;

export const ArticlesIcon = () => {
  return <Articles src={ArticlesPNG} />;
};

const Report = styled.img`
  margin-right: 6px;
  vertical-align: middle;
`;
export const ReportIcon = () => {
  return <Report src={report} />;
};

const CompContainer = styled.img`
  width: 32px;
  height: 32px;
  vertical-align: top;
`;

export const CompIcon = () => {
  return <CompContainer src={Comp} />;
};

const Reports = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 6px;
  vertical-align: top;
`;

export const ReportsIcon = () => {
  return <Reports src={reports} />;
};

const ArticlesContainer = styled.img`
  width: 32px;
  height: 32px;
  vertical-align: top;
`;

export const ArticlesContainerIcon = () => {
  return <ArticlesContainer src={gg} />;
};

// ant icons
const MyReports = () => {
  return <img className="silder-icon" src={myreports} />;
};

const MyReportsUnselect = () => {
  return <img className="silder-icon" src={myreports_unselect} />;
};

export const MyReportsIcon = ({ selectedKeys }) => {
  return (
    <Icon
      component={selectedKeys === 'my_report' ? MyReports : MyReportsUnselect}
    />
  );
};

const MyTeam = () => {
  return <img className="silder-icon" src={myTeam} />;
};

const MyTeamUnselect = () => {
  return <img className="silder-icon" src={myTeam_unselect} />;
};

export const PolicyIcon = ({ selectedKeys }) => {
  return (
    <Icon component={selectedKeys === 'policy' ? MyTeam : MyTeamUnselect} />
  );
};

export const MyTeamIcon = ({ selectedKeys }) => {
  return (
      <Icon component={selectedKeys === 'team' ? MyTeam : MyTeamUnselect} />
  );
};

const MyInfo = () => {
  return <img className="silder-icon" src={myInfo} />;
};

const MyInfoUnselect = () => {
  return <img className="silder-icon" src={myInfo_unselect} />;
};

export const MyInfoIcon = ({ selectedKeys }) => {
  return (
    <Icon component={selectedKeys === 'my_info' ? MyInfo : MyInfoUnselect} />
  );
};

export const MfAdministratorIcon = ({ selectedKeys }) => {
  return (
      <Icon component={selectedKeys === 'mf_administrator' ? MyInfo : MyInfoUnselect} />
  );
};

const SetAvatar = () => {
  return <img className="silder-icon" src={setAvatar} />;
};

const SetAvatarUnselect = () => {
  return <img className="silder-icon" src={setAvatar_unselect} />;
};

export const SetAvatarIcon = ({ selectedKeys }) => {
  return (
    <Icon
      component={selectedKeys === 'set_avater' ? SetAvatar : SetAvatarUnselect}
    />
  );
};

const SetPassword = () => {
  return <img className="silder-icon" src={setPassword} />;
};
const SetPasswordUnselect = () => {
  return <img className="silder-icon" src={setPassword_unselect} />;
};

export const SetPasswordIcon = ({ selectedKeys }) => {
  return (
    <Icon
      component={
        selectedKeys === 'set_passeord' ? SetPassword : SetPasswordUnselect
      }
    />
  );
};

const TwoFASelected = () => {
  return <img className="silder-icon" src={twoFA_selected} />;
};
const TwoFAUnSelected = () => {
  return <img className="silder-icon" src={twoFA_unselected} />;
};
export const TwoFAIcon = ({ selectedKeys }) => {
  return (
    <Icon
      component={
        selectedKeys === '2fa' ? TwoFASelected : TwoFAUnSelected
      }
    />
  );
};

const Search = () => {
  return (
    <img
      src={Search_PNG}
      style={{
        width: '14px',
        height: '14px',
        marginTop: '-6px',
      }}
    />
  );
};

export const SearchIcon = () => {
  return <Icon component={Search} />;
};

const Enter = () => {
  return (
    <img
      src={Enter_PNG}
      style={{
        width: '14px',
        height: '14px',
        marginTop: '-6px',
      }}
    />
  );
};

export const EnterIcon = () => {
  return <Icon component={Enter} />;
};

const ADDreport = () => {
  return (
    <img
      src={ADDReportPNG}
      style={{
        width: '15px',
        height: '16px',
        marginTop: '-6px',
      }}
    />
  );
};

export const ADDreportIcon = () => {
  return <Icon component={ADDreport} />;
};

// company-center

const c_report = () => {
  return <img className="silder-icon" src={companyReport} />;
};
const c_report_unselect = () => {
  return <img className="silder-icon" src={companyReport_unselect} />;
};

export const Creport = ({ selectedKeys }) => {
  return (
    <Icon
      component={selectedKeys === 'my_report' ? c_report : c_report_unselect}
    />
  );
};

const c_info = () => {
  return <img className="silder-icon" src={companyInfo} />;
};

const c_info_unselcet = () => {
  return <img className="silder-icon" src={companyInfo_unselect} />;
};

export const Cinfo = ({ selectedKeys }) => {
  return (
    <Icon component={selectedKeys === 'mf_info' ? c_info : c_info_unselcet} />
  );
};

const c_logo = () => {
  return <img className="silder-icon" src={companyLogo} />;
};
const c_logo_unselect = () => {
  return <img className="silder-icon" src={companyLogo_unselect} />;
};

export const Clogo = ({ selectedKeys }) => {
  return (
    <Icon
      component={selectedKeys === 'mf_set_logo' ? c_logo : c_logo_unselect}
    />
  );
};

const c_password = () => {
  return <img className="silder-icon" src={companyPassword} />;
};
const c_password_unselect = () => {
  return <img className="silder-icon" src={companyPassword_unselect} />;
};

export const Cpassword = ({ selectedKeys }) => {
  return (
    <Icon
      component={
        selectedKeys === 'mf_set_passeord' ? c_password : c_password_unselect
      }
    />
  );
};

export const CompanyTypeIcon = () => {
  return <img className="silder-icon" src={companyTypeIcon} style={{
    width:'14px',
    height:'14px',
    marginRight:'8px'
  }}/>;
};

export const TwoFaConfiguredIcon = () => {
  return <img className="silder-icon" src={TwoFaConfigured} style={{
    width:'28px',
    height:'28px',
    margin:'11px'
  }}/>;
};
